export const REQUEST_SEARCH_LOGS = 'REQUEST_SEARCH_LOGS';
export const RECEIVE_SEARCH_LOGS = 'RECEIVE_SEARCH_LOGS';
export const RESET_SEARCH_LOGS = 'RESET_SEARCH_LOGS';
